export default __webpack_public_path__ + "static/media/etc.6b7eff69.png";